import UrlHelper from './url_helper';

$(document).on('ready turbolinks:load', () => {
  const $input = $('input[data-submit-with-turbolinks]');
  $input.off('keyup').keyup((e) => {
    if (e.keyCode === 13) {
      const params = {};
      $input.closest('.page-search').find('input').each((index, input) => {
        if (input.value.length > 0) {
          params[encodeURIComponent(input.name)] = encodeURIComponent(input.value);
        }
      });
      Turbolinks.visit(new UrlHelper($input.data('url')).urlByAppendingParams(params));
    }
  });
});
